
import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BuildNumberDirective} from '@app/shared/directives/build-number.directive';
import {environment} from '@environments/environment';
import {DialogModule} from 'primeng/dialog';
import {DividerModule} from 'primeng/divider';
import packageJson from '../../../../../package.json';

@Component({
  selector: 'app-build-number',
  imports: [BuildNumberDirective, DialogModule, DividerModule, FormsModule],
  template: `
    @if (showBuildNumber) {
<span appBuildNumber class="build-number" (showDialog)="onToggleDialog()">{{
      buildNumber
    }}</span>
}
    @if (!showBuildNumber) {
<span appBuildNumber class="build-number-print" (showDialog)="onToggleDialog()">{{
      buildNumber
    }}</span>
}
    <p-dialog header="App Info" [(visible)]="isVisible" [modal]="true" [draggable]="false" [resizable]="false">
      <p><strong>Build number:</strong> {{ buildNumber }}</p>
      <p-divider />
      <p><strong>Environment:</strong> {{ baseUrl }}</p>
      <p-divider />
      <p><strong>App version:</strong> {{ appVersion }}</p>
      <p-divider />
    </p-dialog>
  `,
})
export class BuildNumberComponent {
  showBuildNumber = environment.showBuildNumber?.toLowerCase() === 'yes';
  buildNumber = environment.buildNumber;
  baseUrl = this.getEnvironment();
  appVersion = packageJson.version;
  isVisible = false;

  onToggleDialog(): void {
    this.isVisible = !this.isVisible;
  }

  getEnvironment(): string {
    return window.origin;
  }
}
